/* eslint-disable no-shadow */

enum EnumIntegrationType {
  OldPlatform = 1,
  DataWarehouse = 2,
  RunAnalyser = 3,
}

export default EnumIntegrationType;
